import React from 'react';
import { graphql } from 'gatsby';

import IDEImage from '../assets/GridCard/ide.svg';
import Banner from '../components/Banner/Banner';
import BgBanner from '../components/BgBanner/BgBanner';
import { IconLinkTo } from '../components/Icons';
import Layout from '../components/Layout';
import NestedPages from '../components/pages/NestedPages/NestedPages';
import PageTitle from '../components/PageTitle/PageTitle';
import SEO from '../components/seo';
import { PageProps } from '../entities/Page';
import { programmingNavigation } from '../utils/constants';
import ConnectAndContribute from '../components/ConnectAndContribute/ConnectAndContribute';
import LearnArduino from '../assets/learn-arduino.png';
import ProgrammingSideBar from '../components/SideBar/ProgrammingSidebar';

export default function Programming({ data }: PageProps): React.ReactElement {
  return (
    <Layout>
      <SEO
        title="Programming"
        description="Learn all you need to know about the Arduino programming language as well as other compatible languages."
      />
      <main className="page-container">
        <ProgrammingSideBar links={programmingNavigation} actualPage={'Programming'} />
        <div className="page-layout programming">
          <PageTitle
            title="Programming"
            description="Learn all you need to know about the Arduino programming language as well as other compatible languages."
          />
          <NestedPages>{data.pages}</NestedPages>
          <Banner
            title="Download IDE"
            description="Discover all the features of the Arduino IDE, our most popular programming tool."
            image={IDEImage}
            cta={[{ url: 'https://www.arduino.cc/en/software', label: 'DOWNLOAD IDE', icon: <IconLinkTo />, external: true }]}
          />
          <BgBanner
            title="Learn Arduino Basics"
            description="Basic knowledge about principles and techniques behind the Arduino ecosystem."
            image={LearnArduino}
            cta={{ url: '/learn', label: 'Learn Arduino' }}
          />
          <ConnectAndContribute />
        </div>
      </main>
    </Layout>
  );
}

export const pageQuery = graphql`
  {
    pages: allFile(filter: { fields: { type: { eq: "programming" } } }, sort: { relativeDirectory: ASC }) {
      edges {
        node {
          relativeDirectory
          name
          fields {
            slug
          }
          childMdx {
            frontmatter {
              title
              url
              icon
              external
              links {
                title
                url
              }
            }
          }
        }
      }
    }
  }
`;
